<div class="modal-card card">
  <div class="card-header">
    <div class="row align-items-center">
      <div class="col">
        <h3 class="card-header-title">{{ 'DELETE_CORPORATE_MODAL.TITLE' | translate }}</h3>
      </div>
      <div class="col-auto">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          (click)="emitDismiss.emit()"
          aria-hidden="true">×
        </button>
      </div>
    </div>
  </div>
  <div class="card-body">
    <div class="alert alert-danger mb-0">{{ 'DELETE_CORPORATE_MODAL.ALERT_MESSAGE' | translate }}</div>
  </div>
  <div class="card-footer text-right">
    <button
      type="button"
      class="btn btn-secondary mr-2"
      (click)="emitDismiss.emit()">
      {{ 'BUTTONS.CANCEL' | translate }}
    </button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="delete();">
      {{ 'BUTTONS.DELETE' | translate }}
    </button>
  </div>
</div>
